import { render, staticRenderFns } from "./Papara.vue?vue&type=template&id=2ac3ef33&scoped=true"
import script from "./Papara.vue?vue&type=script&lang=js"
export * from "./Papara.vue?vue&type=script&lang=js"
import style0 from "./Papara.vue?vue&type=style&index=0&id=2ac3ef33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3ef33",
  null
  
)

export default component.exports